<script setup lang="ts">
    import { RefreshTokensCommand } from '@keyvue/one-api-client';
    import useClient from '@/services/keyvue-api/composables/useClient';
    import { useRouter } from 'vue-router';

    const { client } = useClient();
    const router = useRouter();

    const authenticate = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        const redirect = urlParams.get('redirect') ?? '/';

        if (token && client.session.isTokenExpired) {
            try {
                const response = await client.dispatch(
                    new RefreshTokensCommand(token),
                );

                await client.session.applyTokens(
                    response.accessToken,
                    response.refreshToken,
                );
            } catch (err) {
                // Ignore
            }
        }

        if (!client.session.isLoggedIn) {
            router.replace({
                name: 'login',
                query: {
                    redirect: window.location.href,
                },
            });
            return;
        }

        if (redirect.indexOf('http') === 0) {
            window.location.replace(redirect);
        } else {
            router.replace(redirect);
        }
    };

    await authenticate();
</script>
